import http from '../../utils/http'

export const getUserBenefit = () => {
  return http.get('/api/TUserBenefit')
}
